namespace Vit.Administration {
    export interface UserTenantRoleDefinition {
        TenantId?: number;
        TenantName?: string;
        Roles?: number[];
    }
}